
import { defineComponent, PropType, toRefs, watch } from 'vue'
import {
  AkkoCoverageType,
  CoverageType,
  InjuredGadgetsCoverageType,
  PlanIntervals,
} from '@/constants/coverages'
import { CoverageSelection } from '@/types/plan-registration'
import CoveragesCombo from '@/composables/coverages-combo'
import { ModulesIdentifiers } from '@/store'
import { AppGetters } from '@/store/modules/app/getters'
import { PartnerPrograms } from '@/constants/partner-programs'
import PlanSelect from '@/components/common/PlanSelect.vue'
import CloseIcon from '@/components/common/icons/Close-Icon.vue'
import PlanInfo from '@/components/common/PlanInfo.vue'

export default defineComponent({
  name: 'FamilyPlanSelector',
  components: { PlanInfo, CloseIcon, PlanSelect },
  setup(props: {
    planInterval: PlanIntervals
    coverageSelection: CoverageSelection[]
    coverageCombo: CoveragesCombo
  }) {
    const { planInterval, coverageSelection, coverageCombo } = toRefs(props)

    watch(planInterval, () =>
      coverageCombo.value.recalculateCoverages(planInterval.value),
    )

    watch(
      coverageSelection,
      (newValues, prevValues) => {
        if (newValues?.length === 0 && prevValues?.length > 0) {
          coverageCombo.value.selectionMap.indexer = 0
          coverageCombo.value.selectionMap.selections = {}
          coverageCombo.value.recalculateCoverages(planInterval.value)
        }
      },
      { deep: true },
    )

    coverageCombo.value.recalculateCoverages(planInterval.value)
    return {
      CoverageType,
      AkkoCoverageType,
      InjuredGadgetsCoverageType,
      PartnerPrograms,
    }
  },
  methods: {
    isCoverageType(type: CoverageType | null): boolean {
      return this.coverageCombo.coverageType === type
    },
    addPhonePlan() {
      this.coverageCombo.addPhonePlan(this.planInterval)
    },
    addAkkoPlan() {
      this.coverageCombo.addAkkoPlan(this.planInterval)
    },
    addHomeRegularPlan() {
      this.addFamilyPlan(CoverageType.HOME_ELECTRONIC_REGULAR_PLAN)
      this.coverageCombo.addHomeRegularPlan(this.planInterval)
      if (Object.keys(this.coverageCombo.selectionMap.selections).length > 0) {
        this.coverageCombo.registerHomeRegularPlanTypeSelection(
          this.coverageCombo.selectionMap.selections[
            Object.keys(this.coverageCombo.selectionMap.selections)[0]
          ],
        )
      }
    },
    addHomePlusPlan() {
      this.addFamilyPlan(CoverageType.HOME_ELECTRONIC_PLUS_PLAN)
      this.coverageCombo.addHomePlusPlan(this.planInterval)
      if (Object.keys(this.coverageCombo.selectionMap.selections).length > 0) {
        this.coverageCombo.registerHomePlusPlanTypeSelection(
          this.coverageCombo.selectionMap.selections[
            Object.keys(this.coverageCombo.selectionMap.selections)[0]
          ],
        )
      }
    },
  },
  computed: {
    partnerProgram(): string {
      return this.$store.getters[
        `${ModulesIdentifiers.APP}/${AppGetters.PARTNER_PROGRAM}`
      ]
    },
    isInjuredGadgets(): boolean {
      return this.partnerProgram === PartnerPrograms.INJURED_GADGETS
    },
  },
  props: {
    planInterval: {
      type: String as PropType<PlanIntervals>,
      required: true,
    },
    coverageSelection: {
      type: Array as PropType<CoverageSelection[]>,
      required: true,
    },
    coverageCombo: {
      type: Object as PropType<CoveragesCombo>,
      required: true,
    },
    addFamilyPlan: {
      type: Function,
      default: () => {
        /* */
      },
    },
  },
})
